import { Keys } from '../types';

const keys: Keys = {
  infura: 'daaa68ec242643719749dd1caba2fc66',
  alchemy: 'trix72l2oM0eJK0UB8YfR',
};

export default keys;
